<template>
    <div class="screen">
    <ion-backdrop v-if="isBackdrop"></ion-backdrop>

    <ion-header v-if="!isModal">
      <h2 style="overflow-wrap: break-word;">{{ $store.state.restaurantActive.restaurantName }}</h2>
          <ion-toolbar>
            <ion-buttons slot="start">
              <ion-back-button default-href="/controlPanel" @click="backtoList()"></ion-back-button>
            </ion-buttons>
            <ion-label style="padding: 20px 100px;">
              <h1>{{title}}</h1>            
            </ion-label>
          </ion-toolbar>
    </ion-header>
    <br/>

    <ion-loading
        v-if="spinner"
        cssClass="my-custom-class"
        :message="$t('frontend.tooltips.loadRestaurant')"
    ></ion-loading>

    <div >
        <ion-row>

          <ion-col size="12" size-md="6">

             <ion-item>
              <ion-label position="floating"><span style="color: red">*</span>{{$t('backoffice.form.fields.name')}}</ion-label>
                <ion-input class="input-style" type="text" name="name" autocomplete="name"
                @input="name = $event.target.value" 
                v-bind:value="name">
              </ion-input>
            </ion-item>

            <ion-item style="--border-style: none;">
              <ion-label position="floating"><span style="color: red">*</span>Country</ion-label>
              <ion-input id="pacInput" ref="pacInput" class="input-style" type="tel" name="name"
              @input="country = $event.target.value" 
              v-bind:value="country">
              </ion-input>
            </ion-item>

            <ion-item>
              <ion-label position="floating">{{$t('backoffice.form.fields.phone')}}</ion-label>
                <ion-input class="input-style" type="text" name="phone" autocomplete="phone"
                @input="handlePhoneInput" 
                v-bind:value="phone">
              </ion-input>
            </ion-item>

          </ion-col>

          <ion-col size="12" size-md="6">
            <ion-item>
              <ion-label position="floating"><span style="color: red">*</span>{{$t('backoffice.form.fields.email')}}</ion-label>
              <ion-input class="input-style" type="email" name="email" autocomplete="email"
              @input="email = $event.target.value" 
              v-bind:value="email">
              </ion-input>
            </ion-item>

            <ion-item>
                <ion-label>{{$t('backoffice.form.titles.state')}}</ion-label>
                <ion-toggle slot="end" name="state" 
                      @ionChange="state=$event.target.checked" 
                      :checked="state">
                </ion-toggle>
            </ion-item>


          </ion-col>

        </ion-row> 
    
      <br/>
      <ion-button expand="full" color="primary" :disabled="!isValidForm()" @click="saveSuscription()">{{ $t('backoffice.form.buttons.save') }}</ion-button>

    </div>
    </div>
</template>

<script>

import { Api } from '../api/api.js';
//import Moment from 'moment'
import { DateTime } from 'luxon';
import Swal from "sweetalert2"
import PhoneNumber from 'libphonenumber-js';
import { NotificationUtil } from '../utils/email.js';
import CreditCardSaved from '../../frontend/components/CreditCardSaved.vue';

export default {

  name: 'subscriberForm',
  components: {
    CreditCardSaved
  },
  props: {
    recivedEmail: {
      type: String,
      default: ''
    },
    recivedPhone: {
      type: String,
      default: ''
    },
    isModal: { 
      type: Boolean,
      default: false
    },
    subscriberId:{
      type: String,
      default: ''
    },
    fromSchedule:{
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      modelName: 'users/subscriber',
      /****** Form Data ******/
      id: null,
      subscriber: null,

      name: '',
      phone: '',
      email: '',
      country:'',
      state: true,
      abreviature:'',
      pacInput: null,
      isBackdrop: false,

      spinner: false,
    }
  },
  created: function(){
    console.log("Email recibido en SubscriberForm.vue:", this.recivedEmail); // Verificar el email
    if (this.recivedEmail) {
      this.email = this.recivedEmail; // Asignar el email recibido
    }
    if (this.recivedPhone) {
      this.phone = this.recivedPhone; // Asignar el número de teléfono recibido
    }
      this.init();    
  },
  computed: {
      title() {
          let t = this.$t('backoffice.form.titles.suscriptionNewTitle')
          if (this.id)
              t = this.$t('backoffice.form.titles.suscriptionEditTitle')

          return t;
          // return ""
      }
  },
  mounted() {
    this.initApp();
  },
  methods: {

    handlePhoneInput(event) {
      this.phone = event.target.value;
      const phoneNumber = new PhoneNumber(this.phone,this.abreviature); //We need put especific abreviature of country

      if (phoneNumber.isValid()) {
        const formattedPhoneNumber = phoneNumber.formatInternational();
        this.phone = formattedPhoneNumber;
      }
    },
    async initApp() {
      await new Promise(resolve => setTimeout(resolve, 500));
      const input = document.querySelector('#pacInput input');
      const autocomplete = new google.maps.places.Autocomplete(input);

      autocomplete.setTypes(['(regions)']); // Restrict autocomplete to countries

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (place && place.address_components) {
          // Loop through address components to find the country
          for (const addressComponent of place.address_components) {
            if (addressComponent.types.includes("country")) {
              this.country = addressComponent.long_name;
              this.abreviature = addressComponent.short_name;
              break; // We found the country, so exit the loop
            }
          }
        }
      });
    },

    init(){

        this.id = this.$route.params.subscriberId || this.subscriberId;
        if(this.subscriberId !== ''){
          this.id = this.subscriberId;
        }
        if (this.id){
          const data = this.$store.state.backConfig.subscriber.find(s => s._id === this.id);
          if(data){
            console.log({data})
            this.name = data.Name;
            this.phone = data.Phone;
            this.country = data.Country;
            this.email = data.Email;
            this.state = data.State;                 
            this.subscriber = data;
          }
         }       
    },

    ifErrorOccured(action){
      return this.$ionic.alertController.create({
          title: this.$t('backoffice.list.messages.connectionError'),
          message: this.$t('backoffice.list.messages.connectionErrorMessage'),
          buttons: [
            {
              text: this.$t('backoffice.list.messages.buttons.goToList'),
              handler: () => {
                  this.$router.push({
                      name: 'Subscriber',
                  });
              }
            },
            {
              text: this.$t('backoffice.list.messages.buttons.retry'),
              handler: () => {
                  action();
              }
            }
          ]
        })
        .then(a => a.present());
    },

    ShowMessage(type, message, topic=''){
        return this.$ionic.alertController
          .create({
            cssClass: 'my-custom-class',
            header: type,
            subHeader: topic,
            message: message,
            buttons: [this.$t('backoffice.form.messages.buttons.ok')],
          })
        .then(a => a.present())
    },

    showToastMessage(message, tColor){
       return this.$ionic.toastController.create({
        color: tColor,
        position: 'top',
        duration: 3000,
        message: message,
        showCloseButton: false
      }).then(a => a.present())
    },

    backtoList(){
        this.$router.push(
          { 
            name: 'Subscriber'
          }
        )
    },

    isValidForm(){
        // let errors = [];

        if (this.name == "")
        {
            // errors.push(this.$t('backoffice.form.validate.firstName'));
            return false
        }
        if (this.email == "")
        {
            // errors.push(this.$t('backoffice.form.validate.email'));
            return false
        }
        if (this.email != "")
        {
            let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
            if (emailRegex.test(this.email) == false)
            {
                // errors.push(this.$t('backoffice.form.validate.emailIncorrect'));
                return false
            }
        }

        return true
    },
    //Create or edit a new category
    saveSuscription: async function() {
        if (this.isValidForm()) {
            this.isBackdrop = true;

            let item = {
                "Name": this.name,
                "Country": this.country,
                "Phone": this.phone,
                "Email": this.email,
                "State": this.state,
                "Date": DateTime.local().toISO()
            };

            // If I am editing
            if (this.id) {
                item['_id'] = this.id;

                this.spinner = true;
                try {
                    const response = await Api.putIn(this.modelName, item);
                    const index = this.$store.state.backConfig.subscriber.findIndex(s => s._id === this.id);
                    if (index !== -1) this.$store.state.backConfig.subscriber[index] = item;
                    Swal.fire({
                        title: this.$t('backoffice.list.messages.messageEditSuccessSuscriptor'),
                        icon: 'success',
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    });
                    this.spinner = false;
                    if(this.fromSchedule){
                      const toEmail = '';
                      const toPhone = '';
                      const scheduledAt = '';
                      const cb = '';
                      let emailLabel = null;
                      const showButtons = '';
                      NotificationUtil.bulkSendEmail(toEmail, toPhone, scheduledAt, cb, emailLabel, showButtons)
                      this.$emit('close-modal');
                      return;
                    }
                    this.$router.push({
                        name: 'Subscriber',
                    });
                    return response;
                } catch (error) {
                    this.isBackdrop = false;
                    error;
                    this.spinner = false;
                    this.ifErrorOccured(this.saveSuscription);
                }
            } else {
                // Else, I am creating a new category
                this.spinner = true;
                try {
                    const response = await Api.postIn(this.modelName, item);
                    this.$store.state.backConfig.subscriber.push(response.data);
                    Swal.fire({
                        title: this.$t('backoffice.list.messages.messageCreateSuccessSuscriptor'),
                        icon: 'success',
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    });
                    this.spinner = false;
                    if (this.isModal) {
                      this.$emit('dismiss-modal', response.data);
                      this.$emit('close-modal');
                    } else {
                      this.$router.push({ name: 'Subscriber' });
                    }
                    // this.$router.push({
                    //     name: 'Subscriber',
                    // });
                    return response;
                } catch (error) {
                    this.isBackdrop = false;
                    error;
                    this.spinner = false;
                    this.ifErrorOccured(this.saveUser);
                }
            }
        }
    }
    // saveSuscription: async function(){
    //     if (this.isValidForm())
    //     {
    //         this.isBackdrop = true;         
    //         let item = {
    //           "Name": this.name,
    //           "Phone": this.phone,
    //           "Email": this.email,
    //           "State": this.state,
    //           "Date": Moment().toISOString()
    //         }
    //         //If I am editing
    //         if (this.id){
    //           item['_id'] = this.id;
              
    //           this.spinner = true;
    //           await Api.putIn(this.modelName, item)
    //               .then(response => {
    //                     const index = this.$store.state.backConfig.subscriber.findIndex(s => s._id === this.id);
    //                     if(index !== -1) this.$store.state.backConfig.subscriber[index] = item;
    //                     Swal.fire({
    //                       title: this.$t('backoffice.list.messages.messageEditSuccessSuscriptor'),
    //                       icon: 'success',
    //                       toast: true,
    //                       position: 'top-end',                  
    //                       showConfirmButton: false,
    //                       timer: 3000
    //                     }); 
    //                     //this.showToastMessage(this.$t('backoffice.list.messages.messageEditSuccessSuscriptor'), "success");
    //                     this.spinner = false;
    //                     this.$router.push({
    //                       name: 'Subscriber',
    //                     });
    //                     return response;
    //               })
    //               .catch(e => {
    //                     this.isBackdrop = false;
    //                     e;
    //                     this.spinner = false;
    //                     this.ifErrorOccured(this.saveSuscription);
    //               })
    //         }
    //         else{
    //           //Else, I am created a new category
    //           this.spinner = true;
    //           await Api.postIn(this.modelName, item)
    //               .then(response => {
    //                   this.$store.state.backConfig.subscriber.push(response.data);
    //                   Swal.fire({
    //                     title: this.$t('backoffice.list.messages.messageCreateSuccessSuscriptor'),
    //                     icon: 'success',
    //                     toast: true,
    //                     position: 'top-end',                  
    //                     showConfirmButton: false,
    //                     timer: 3000
    //                   }); 
    //                   //this.showToastMessage(this.$t('backoffice.list.messages.messageCreateSuccessSuscriptor'), "success");
    //                   this.spinner = false;
    //                   this.$router.push({
    //                     name: 'Subscriber',
    //                   });
                      
    //                   return response;
    //               })
    //               .catch(e => {
    //                   this.isBackdrop = false;
    //                   e;
    //                   this.spinner = false;
    //                   this.ifErrorOccured(this.saveUser)
    //               })
    //         }
    //     }
    // } 
    },

}
    
</script>

<style>

@media only screen and (min-width : 1024px){

    .screen{
        padding-left: 10%;
        padding-right: 10%;
        border: #edf1ee solid 1px;
        margin-right: 10%;
        margin-left: 10%;
        /* border-radius: 25px; */
    }

}

</style>